import React from "react";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import * as yup from "yup";

import {useCreateMutation} from "../../../hooks/useQueryHooks";
import {ResponseItem} from "../../../models/clientModels/interfaces/Response";

import {yupResolver} from "@hookform/resolvers/yup";
import {useQueryClient} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../../Recoil/Atom/snackBarState";
import * as CategoryApi from "../../../api/educationApi/educationCategoryApi";
import ConfirmButtonGroup from "../../../components/ConfirmButtonGroup";
import SubTitle from "../../../components/SubTitle";
import * as Params from "../../../models/clientModels/interfaces/apiParams";
import {EDCategory, initialEDCategory} from "../../../models/serverModels/education/EDCategory";
import {FormSection} from "../../../styledComponents/StyledCreateForm";
import CategoryForm from "./CategoryForm";
import MWProgress from "../../../components/MWProgress";

const categorySchema = yup.object().shape({
  name: yup.string().required("카테고리를 입력하세요"),
});

const CreateCategory = () => {
  const {param1, param2} = useParams();
  const depth = parseInt(param1!);
  const parentUID = parseInt(param2!);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<EDCategory>,
    Params.Create<EDCategory>
  >({
    api: CategoryApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        switch (depth) {
          case 0:
            navigate(`/Education/CategoryList`);
            break;
          case 1:
            navigate(`/Education/MiddleCategoryList/${parentUID}`);
            break;
          case 2:
            navigate(`/Education/SubCategoryList/${parentUID}`);
            break;
        }
        queryClient.invalidateQueries(["EducationCategoryList"]);
      },
    },
  });
  const methods = useForm<EDCategory>({resolver: yupResolver(categorySchema)});

  const onSubmit: SubmitHandler<EDCategory> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initialEDCategory, ...data, depth, parentUID},
    });
  };

  return (
    <React.Fragment>
      <SubTitle subTitle="분류목록 추가" />
      {isLoading && <MWProgress />}
      <FormProvider {...methods}>
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <CategoryForm />
            <ConfirmButtonGroup
              link="/Education/CategoryList"
              cancelText="취소"
              confirmText="저장"
            />
          </form>
        </FormSection>
      </FormProvider>
    </React.Fragment>
  );
};

export default CreateCategory;
